export default __webpack_public_path__ + "static/media/Slide4.93f4119a.jpeg";